import { render } from "./ArrowLeftWhite.vue?vue&type=template&id=1a23cb32"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowLeftWhite.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a23cb32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a23cb32', __exports__)) {
    api.reload('1a23cb32', __exports__)
  }
  
  module.hot.accept("./ArrowLeftWhite.vue?vue&type=template&id=1a23cb32", () => {
    api.rerender('1a23cb32', render)
  })

}


export default __exports__